export const ReportTypes = {
  DAILY: "DAILY",
  WEEKLY: "WEEKLY",
  SAFETY: "SAFETY",
  REPORTS_TRAINING:'REPORTS_TRAINING',
  REPORTS_OTHER_TRAINING:'REPORTS_OTHER_TRAINING',
  EMPLOYEES: 'EMPLOYEES'
};
